export const SOAR_RATIO = 1000; // changed from 1250 to 1000
export const BREACH_RATIO = 150; // changeed from 500 to 150
export const maxAuthUsers = 100;
export const DISCOUNT_PRICE = 1;
export const LOWER_PRICE_RANGE = 0.8;
export const HIGHER_PRICE_RANGE = 1.2;
export const SOFTWARE_DISCOUNT = 0.55; // 45%
export const SAAS_DISCOUNT = 0.6; // 40%
export const localCurrency = 'us-en';

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30QradarSoar = '30BI1';

// DPART Numbers
export enum PartNumber {
  breach = 'D0DSDZX',
  saas = 'D0DSFZX',
  software = 'D0AE7ZX',
}

// Saas Tier
export const SAAS_TIERS = {
  TIER_1: 1,
  TIER_2: 26,
  TIER_3: 51,
  TIER_4: 101,
};
